import React from "react";

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "rgb(37,74,128)",
        color: "white",
        padding: "15px 20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap"
        }}
      >
        <span style={{ fontSize: "14px" }}>
          Casa de las Lunas Xalapa 2025 | Powered by Google Cloud
        </span>
        <img
          src="/images/gcp-logo.png"
          alt="Google Cloud"
          style={{ height: "28px", objectFit: "contain" }}
        />
      </div>
    </footer>
  );
}
